import React, { useEffect } from 'react';
import AffiliateProgram from '../components/AffiliateProgram';

const AffiliatePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'DigitalGigs Affiliate Program | Earn by Referring Clients';
  }, []);

  return <AffiliateProgram />;
};

export default AffiliatePage;
